<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Collections</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />
      <UploadingStatus ref="uploadingStatus" />
      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
            id="Search"
          ></v-text-field>
        </div>
        <div class="col">
          <v-select
            id="subscriptionType"
            v-model="paging.isASC"
            :items="[{type:'Ascending', value: true}, {type:'Descending', value: false}]"
            label="Order By"
            item-text="type"
            item-value="value"
            return-value="type"
            @change="getCollectionByPagin()"
          ></v-select>
        </div>
        <div class="col">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4" id="btnNew">
              New Collection
            </v-btn>
          </div>
        </div>
      </div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <div v-show="isEdit">
          <div class="row">
            <div class="col">
              <v-text-field
                v-model="selectedObj.Name"
                :rules="nameRules"
                label="Collection Name*"
                id="name"
                required
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                v-model="selectedObj.Description"
                :rules="descriptionRules"
                id="description"
                label="Collection Description"
                required
              ></v-text-field>
            </div>
          </div>

          <div class="row">
            <!-- <div class="col">
              <v-text-field
                v-model="selectedObj.Price"
                label="Price"
                type="number"
                required
                :rules="priceRules"
              ></v-text-field>
            </div> -->
            <div class="col">
              <!-- <v-checkbox
                v-model="selectedObj.isCoreCollection"
                id="isCollection"
                label="Is Core Collection"
              ></v-checkbox> -->
              <!-- <v-select
              id="collectionType"
              v-model="selectedObj.collectionType"
              :items="collectionType"
              label="Collection Type*"
              @change="() => { cartItems = [] }"
              item-text="type"
              item-value="id"
              return-value="id"
            ></v-select> -->
                
              <!-- 
              <v-text-field
                v-model="selectedObj.Seat"
                label="No Of Seats"
                type="number"
                required
                :rules="seatRules"
              ></v-text-field> -->
            </div>
            <div class="col">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-width="200"
                id="cardCollection"
                offset-x
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="indigo" dark v-bind="attrs" v-on="on" plain id="btnCollection">
                    Selected Items For Collection - ( {{ cartItems.length }} )
                  </v-btn>
                </template>

                <v-card>
                  <v-data-table
                    :headers="selectedObj.collectionType === 1 ? cartTableHeader : journalCartTableHeader"
                    :items="cartItems"
                    hide-default-footer
                    :page.sync="cart_page"
                    :items-per-page="cart_itemsPerPage"
                    @page-count="cart_pageCount = $event"
                    height="500"
                  >
                    <template v-slot:item.Action="{ item }">
                      <div>
                        <v-btn
                          icon
                          color="pink"
                          @click="removeFromCart(item.id)"
                          id="btnRemoveCart"
                        >
                          <v-icon>mdi-close-circle-outline</v-icon>
                        </v-btn>
                      </div>
                    </template>
                  </v-data-table>
                  <v-pagination
                    v-model="cart_page"
                    :length="cart_pageCount"
                  ></v-pagination>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="menu = false" id="btnClose">
                      Close
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </div>
          </div>

          <!-- 
          <div class="row" v-show="false">
            <div class="col">
              <v-combobox
                v-model="selectedObj.publications"
                :items="publications"
                :search-input.sync="searchUser"
                item-text="Title"
                item-value="id"
                hide-selected
                hide-no-data
                dense
                label="Add Publication to the collection"
                multiple
                persistent-hint
                chips
                return-object
                deletable-chips
                @change="onChangeUsers"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </div>
          </div>-->

          <div class="row mt-5">
            <div class="col">
              <v-card>
                <div class="row" v-if="selectedObj.collectionType === 2">
                  <div class="col">
                    <v-text-field
                      id="filterIssn"
                      v-model="journalFilters.issn"
                      label="ISSN"
                      class="ml-5"
                    ></v-text-field>
                  </div>
                  <div class="col">
                    <v-select
                      id="filterPublisher"
                      v-model="publisher"
                      :items="publishers"
                      label="Journal Provider"
                      item-text="Name"
                      item-value="Name"
                      return-value="Name"
                      clearable
                      dense
                      class="mt-5"
                    ></v-select>
                  </div>
                </div>
                <div class="row" v-if="selectedObj.collectionType === 2">
                  <div class="col">
                    <v-text-field
                      id="filterOrganization"
                      v-model="organization"
                      label="Organization"
                      class="ml-5"
                    ></v-text-field>
                  </div>
                  <div class="col">
                    <v-text-field
                      id="filterAreas"
                      v-model="Scope"
                      label="Areas"
                    ></v-text-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-5 ml-5">
                    <v-text-field
                      id="SearchPublication"
                      v-model="SearchPublication"
                      label="Search"
                    ></v-text-field>
                  </div>
                  <div class="col-6 text-right">
                    <div class="row">
                      <div class="col">
                        <v-btn
                          v-if="selectedObj.collectionType === 1"
                          id="downloadpublication"
                          color="primary"
                          @click="onDownloadPublications()"
                          class="mt-4"
                        >
                          <v-icon left>mdi-file-delimited-outline</v-icon>BOOK CATALOG</v-btn
                        >
                        <v-btn
                          v-else
                          id="newJournal"
                          color="primary"
                          class="mt-4"
                          @click="openNewJournalDialog"
                          :disabled="!isIssnComplete"
                        >
                          <v-icon left>mdi-book-plus</v-icon>New Journal</v-btn
                        >
                      </div>
                      <div class="col" v-if="selectedObj.collectionType === 1">
                        <v-file-input
                          ref="dataUpload"
                          id="dataUpload"
                          accept=".csv"
                          placeholder="Upload a csv file"
                          prepend-icon="mdi-file-excel"
                          label="Data Upload"
                          @change="onDataUpload"
                        ></v-file-input>
                      </div>
                    </div>
                  </div>
                </div>
                <v-divider></v-divider>

                <div style="height: 350px; overflow-y: scroll">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <!-- <th class="text-left" style="width: 50px"></th> -->
                        <th class="text-left">Title</th>
                        <th class="text-left">
                          {{ selectedObj.collectionType === 2 ? "ISSN" : "ISBN" }}
                        </th>
                        <th class="text-left">{{ selectedObj.collectionType === 2 ? "Journal Provider" : "Publisher" }}</th>
                        <th class="text-left">Action</th>
                        <th></th>
                      </thead>
                      <tbody>
                        <tr v-for="item in resultQuery" :key="item.id" :id="'collection' + item.id">
                          <td>{{ item.Title }}</td>
                          <td>{{ item.ISBN === undefined ? item.ISSN : item.ISBN }}</td>
                          <td>
                            {{
                              selectedObj.collectionType === 2
                                ? item.Publisher
                                : item.PublisherName
                            }}
                          </td>
                          <td>
                            <div>
                              <v-btn
                                :id="'btnAddNew' + item.id"
                                icon
                                v-if="isAdded(item)"
                                @click="addToCart(item)"
                              >
                                <v-icon>mdi-plus</v-icon>
                              </v-btn>
                              <v-icon v-else color="green">mdi-checkbox-marked-circle</v-icon>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </v-card>
              <br />
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="float-right">
                <v-btn @click="onCancel()" id="btnCancel"> Cancel </v-btn>
                <v-btn
                  id="btnSave"
                  class="mr-4"
                  color="primary"
                  @click="onSave()"
                  :loading="loading"
                  :disabled="loading"
                >
                  Save
                </v-btn>
              </div>
            </div>
          </div>
        </div>
        <v-dialog v-model="newJournalDialog" max-width="900">
          <v-card>
            <v-card-title>New Journal</v-card-title>
            <v-card-text>
              <v-form ref="newJournalForm" v-model="newJournalValid" lazy-validation>
                <div class="row">
                  <div class="col">
                    <v-text-field
                      id="newJournalTitle"
                      v-model="newJournal.Title"
                      :rules="TitleRules"
                      label="Title *"
                      required
                    ></v-text-field>
                  </div>
                </div>

                <v-divider class="pt-5"></v-divider>
                <h3 class="mt-5">Journal File & Thumbnail</h3>

                <div class="row">
                  <div class="col">
                    <file-drop
                      v-on:update="onNewJournalFile"
                      v-on:clear="clearNewJournalFile"
                      :fileName="newJournal.fileName"
                      id="dropNewJournalFile"
                    ></file-drop>
                    <div v-show="newJournalFileSize > 0">
                      Size: {{ newJournalFileSize }} MB
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <v-checkbox
                      id="newJournalDefaultThumbnail"
                      v-model="newJournal.isDefaultThumbnail"
                      label="Use default thumbnail"
                      @change="onNewJournalDefaultThumbnail"
                    ></v-checkbox>
                  </div>
                  <div class="col">
                    <div class="row">
                      <div class="col-10">
                        <v-file-input
                          id="newJournalThumbnail"
                          accept="image/png, image/jpeg"
                          placeholder="Thumbnail"
                          prepend-icon="mdi-camera"
                          label="Thumbnail *"
                          v-model="newJournal.thumbnailData"
                          @change="onNewJournalThumbnail"
                          v-show="!newJournal.isDefaultThumbnail"
                          class="mt-5"
                        ></v-file-input>
                      </div>
                      <div class="col-2 ThumbnailImg" style="width: 50px">
                        <div class="float-right">
                          <img
                            :src="newJournal.ThumbnailPath"
                            width="50"
                            id="newJournalThumbnailPreview"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-form>

              <div v-if="draftJournals.length" class="mt-4">
                <h4>Added Journals</h4>
                <v-simple-table class="mt-2">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Title</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in draftJournals" :key="item.tempId || index">
                        <td>{{ item.Title }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="cancelNewJournalDialog">Cancel</v-btn>
              <v-btn color="primary" @click="addDraftJournal" :disabled="!canAddDraftJournal">Add</v-btn>
              <v-btn
                color="primary"
                :loading="newJournalSaving"
                :disabled="newJournalSaving || !draftJournals.length"
                @click="saveDraftJournals"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-form>

      <div class="row" v-show="!isEdit">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <PublicationList ref="publicationList" />
          <!--loading screen untill the publications is completely  loaded-->
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" @click="sortByName" style="cursor: pointer;">Name</th>
                  <!-- <th class="text-left" @click="sortByType" style="cursor: pointer;">Type</th> -->
                  <th class="text-left" @click="sortByDescription" style="cursor: pointer;">Description</th>
                  <th class="text-left" @click="sortByCreatedAt"  style="cursor: pointer;">
                    Created
                  </th>
                  <th class="text-left" @click="sortByUpdatedAt"  style="cursor: pointer;">
                    Modified
                  </th>
                  <th class="text-left" @click="sortByItemCount" style=" cursor: pointer;">
                    # of Publications
                  </th>
                  <!-- <th style="width: 100px">Price</th> -->
                  <!--  <th style="width: 100px">No of Seat</th> -->
                  <th style="width: 200px" class="ml-10"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id" :id="'collection' + item.id">
                  <td>{{ item.Name }}</td>
                  <!-- <td> {{ item.collectionType === 1 ? 'Book' : item.collectionType === 2 ? 'Journal' : '-' }}</td> -->
                  <td>{{ item.Description }}</td>
                  <td>{{item.createDateTime | dateUtcToLocal }}</td>
                  <td>{{ item.modifiedDateTime | dateUtcToLocal }}</td>
                  <td>
                    <div class="d-flex justify-center">
                      <!-- number of books/journals -->
                      {{ item.collectionType === 1 ? item.publicationcount : item.journalcount || 0 }}
                    </div>
                  </td>
                  <!-- <td class="text-right">{{ item.Price }}</td> -->
                  <!--   <td class="text-right">{{ item.Seat }}</td> -->
                  <td>
                    <v-icon class="mr-1 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-1 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                    <v-icon
                          class="mr-1"
                          @click="getCollectionList(item.id, item.collectionType)">
                          mdi-view-grid-outline
                    </v-icon>
                  <!--if collectionType == 1 show download icon-->
                    <v-icon
                      v-if="item.collectionType === 1"
                      class="mr-1"
                      @click="onDownloadCollection(item)"
                    >
                      mdi-cloud-download
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>
<script>
import lodash from "lodash";
import csv from 'csvtojson';
import { Parser } from "json2csv";
import fileUploadService from "../api/fileUploadService";
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";
import * as api from "@/api";
import UploadingStatus from "../components/UploadingStatus.vue";
import PublicationList from "../components/PublicationList.vue";
import FileDrop from "../components/FileDrop";
import { v4 as uuidv4 } from "uuid";
import { sortBy } from "lodash";

export default {
  name: "Collection",
  components: {
    Notification,
    ConfirmationDialog,
    Pagination,
    UploadingStatus,
    PublicationList,
    FileDrop
  },
  created() {
    this.getCollectionByPagin();
    this.getPublication();
    this.getJournals();
    this.getUserCollections();
    this.getPublishers();
  },
  computed: {
    canAddDraftJournal() {
      const hasTitle = (this.newJournal.Title || "").trim().length > 0;
      const hasFile = !!this.newJournal.file && !!this.newJournal.fileName;
      const hasThumbnail =
        this.newJournal.isDefaultThumbnail ||
        !!this.newJournal.thumbnailData ||
        !!this.newJournal.thumbnail;

      // Treat ISSN as required since you already validate it elsewhere
      return this.isIssnComplete && hasTitle && hasFile && hasThumbnail;
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    resultQuery() {
      if (this.selectedObj.collectionType == 1) {
        if (this.SearchPublication) {
          return this.publications.filter(item => {
            return this.SearchPublication.toLowerCase()
              .split(" ")
              .every(
                v =>
                  item.Title.toLowerCase().includes(v) ||
                  item.ISBN.toLowerCase().includes(v) ||
                  item.PublisherName.toLowerCase().includes(v)
              );
          });
        } else {
          return this.publications;
        }
      }
      else if (this.selectedObj.collectionType == 2) {
        const search = (this.SearchPublication || "").toLowerCase().trim();
        const issn = (this.journalFilters.issn || "").toLowerCase().trim();
        const publisher = (this.journalFilters.publisher || "").toLowerCase().trim();
        const organization = (this.journalFilters.organization || "").toLowerCase().trim();
        const Scope = (this.journalFilters.Scope || "").toLowerCase().trim();

        return this.journals.filter(item => {
          const title = (item.Title || "").toLowerCase();
          const itemIssn = (item.ISSN || "").toLowerCase();
          const itemPublisher = (item.Publisher || "").toLowerCase();
          const itemOrganization = (item.Organization || "").toLowerCase();
          const itemAreas = (item.Scope || "").toLowerCase();

          const matchesSearch =
            !search || title.includes(search) || itemPublisher.includes(search);

          return (
            matchesSearch &&
            (!issn || itemIssn.includes(issn)) &&
            (!publisher || itemPublisher.includes(publisher)) &&
            (!organization || itemOrganization.includes(organization)) &&
            (!Scope || itemAreas.includes(Scope))
          );
        });
      }
    },
    isIssnComplete() {
      const value = (this.journalFilters.issn || "").trim();
      if (!value) return false;
      const normalized = value.replace(/\s+/g, "");
      return /^(?:\d{4}-\d{3}[\dXx]|\d{7}[\dXx])$/.test(normalized);
    }
  },
  methods: {
    async onDownloadCollection(item) {
      const isBookCollection = item.collectionType === 1;
      const endpoint = isBookCollection
        ? "publication-collection/publication"
        : "journal-collection/journal";

      try {
        const response = await api.getByID(endpoint, item.id);
        const items = response.data || [];

        const rows = items.map((entry) => {
          const baseRow = {
            Title: entry.Title || "",
            "Publisher Name": entry.PublisherName || entry.Publisher || "",
            "Author": entry.AuthorName ||  "",
            "Published Date": entry.PublishedDate || "",
          };

          if (isBookCollection) {
            return {
              ...baseRow,
              ISBN: entry.ISBN || ""
            };
          }

          return {
            ...baseRow,
            ISSN: entry.ISSN || ""
          };
        });

        const parser = new Parser();
        const csv = parser.parse(rows);
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute(
          "download",
          `${(item.Name || "collection").replace(/\s+/g, "-")}-${isBookCollection ? "books" : "journals"}.csv`
        );
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Failed to download collection", error);
        this.notify.type = 4;
        this.notify.errors = ["Failed to download collection data."];
      }
  },
    isIssnCompleteValue(value) {
      const normalized = (value || "").trim().replace(/\s+/g, "");
      return /^(?:\d{4}-\d{3}[\dXx]|\d{7}[\dXx])$/.test(normalized);
    },
    openNewJournalDialog() {
      if (!this.isIssnComplete) {
        this.notify.type = 4;
        this.notify.errors = ["Please enter a complete ISSN (e.g. 1234-5678)."];
        return;
      }
      this.resetNewJournalForm();
      this.newJournalDialog = true;
    },
    resetNewJournalForm() {
      this.newJournal = {
        id: 0,
        Title: "",
        ISSN: this.journalFilters.issn || "",
        Publisher: "",
        Organization: "",
        Scope: "",
        file: null,
        fileName: "",
        journal_file_length: 0,
        thumbnail: "",
        thumbnailData: "",
        thumbnailFileName: "",
        ThumbnailFileType: "",
        ThumbnailPath: "",
        ThumbnailPathOld: "",
        isDefaultThumbnail: false,
        uuid: ""
      };
      this.newJournalFileSize = 0;
      if (this.$refs.newJournalForm) {
        this.$refs.newJournalForm.resetValidation();
      }
    },
    cancelNewJournalDialog() {
      this.newJournalDialog = false;
      this.draftJournals = [];
      this.resetNewJournalForm();
    },
    onNewJournalFile(fileList) {
      if (!fileList || !fileList.length) return;
      this.newJournal.file = fileList[0];
      this.newJournal.fileName = fileList[0].name;
      this.newJournal.journal_file_length = fileList[0].size;
      this.newJournalFileSize = (fileList[0].size / (1024 * 1024)).toFixed(2);
    },
    clearNewJournalFile() {
      this.newJournal.file = null;
      this.newJournal.fileName = "";
      this.newJournal.journal_file_length = 0;
      this.newJournalFileSize = 0;
    },
    onNewJournalThumbnail() {
      if (!this.newJournal.thumbnailData) return;
      this.newJournal.thumbnailFileName = this.newJournal.thumbnailData.name;
      const reader = new FileReader();
      reader.readAsDataURL(this.newJournal.thumbnailData);
      reader.onload = (result) => {
        this.newJournal.thumbnail = result.currentTarget.result;
        this.newJournal.ThumbnailPath = result.currentTarget.result;
        this.newJournal.ThumbnailPathOld = result.currentTarget.result;
      };
    },
    onNewJournalDefaultThumbnail() {
      if (this.newJournal.isDefaultThumbnail) {
        this.newJournal.ThumbnailPath =
          "https://storage.googleapis.com/prothumia/eBooks/Default_Thumbnail.png";
      } else {
        this.newJournal.ThumbnailPath = this.newJournal.ThumbnailPathOld || "";
      }
    },
    addDraftJournal() {
      if (!this.isIssnComplete) {
        this.notify.type = 4;
        this.notify.errors = ["Please enter a complete ISSN (e.g. 1234-5678)."];
        return;
      }

      this.newJournal.ISSN = this.journalFilters.issn;
      this.newJournal.Publisher = this.publisher;
      this.newJournal.Organization = this.organization;
      this.newJournal.Scope = this.Scope;
      const draftErrors = this.getJournalDraftErrors(this.newJournal);
      if (draftErrors.length) {
        this.notify.type = 4;
        this.notify.errors = draftErrors;
        return;
      }

      if (this.$refs.newJournalForm) {
        const isValid = this.$refs.newJournalForm.validate();
        if (!isValid) return;
      }

      const draft = Object.assign({}, this.newJournal, {
        tempId: Date.now()
      });

      this.draftJournals.push(draft);
      this.resetNewJournalForm();
    },
    async saveDraftJournals() {
      if (this.newJournalSaving) return;
      if (!this.draftJournals.length) {
        this.newJournalDialog = false;
        return;
      }

      const validationErrors = [];
      for (const draft of this.draftJournals) {
        const draftErrors = this.getJournalDraftErrors(draft);
        if (draftErrors.length) {
          const label = draft.Title ? `"${draft.Title}"` : "(untitled)";
          validationErrors.push(`Draft ${label}: ${draftErrors.join(" ")}`);
        }
      }

      if (validationErrors.length) {
        this.notify.type = 4;
        this.notify.errors = validationErrors;
        return;
      }

      this.newJournalSaving = true;
      this.overlay = true;
      this.notify.type = 0;
      this.notify.errors = [];

      try {
        const savedItems = [];
        for (const draft of this.draftJournals) {
          const saved = await this.saveSingleJournal(draft);
          if (saved) savedItems.push(saved);
        }

        if (savedItems.length) {
          for (const item of savedItems) {
            this.addToCart({
              id: item.id || item.uuid || Date.now(),
              Title: item.Title,
              ISSN: item.ISSN,
              PublisherName: item.Publisher
            });
          }
        }

        this.getJournals();
        this.draftJournals = [];
        this.newJournalDialog = false;
      } catch (error) {
        const message =
          (error && error.response && error.response.data &&
            (error.response.data.message || error.response.data.error)) ||
          (error && error.message) ||
          String(error);
        this.notify.type = 4;
        this.notify.errors.push("Failed to save journal data. " + message);
      } finally {
        this.newJournalSaving = false;
        this.overlay = false;
      }
    },
    getJournalDraftErrors(draft) {
      const errors = [];

      if (!this.isIssnCompleteValue(draft.ISSN)) {
        errors.push("Complete ISSN is required (e.g. 1234-5678).");
      }

      if (!draft.Title) {
        errors.push("Title is required.");
      }

      if (!draft.fileName || !draft.file) {
        errors.push("Journal file is required.");
      } else {
        const ext = draft.fileName.split(".").pop().toLowerCase();
        if (ext !== "pdf" && ext !== "epub") {
          errors.push("Invalid file type. Only .pdf or .epub allowed.");
        }
      }

      if (!draft.isDefaultThumbnail && !draft.thumbnail && !draft.thumbnailData) {
        errors.push("Thumbnail is required or choose default thumbnail.");
      }

      return errors;
    },
    async saveSingleJournal(draft) {
      const payload = {
        id: draft.id || 0,
        Title: draft.Title || "",
        ISSN: draft.ISSN || "",
        Publisher: draft.Publisher || "",
        Organization: draft.Organization || "",
        Scope: draft.Scope || "",
        isDefaultThumbnail: draft.isDefaultThumbnail || false,
        ThumbnailPath: draft.ThumbnailPath || "",
        ThumbnailFileType: draft.ThumbnailFileType || "",
        thumbnail: draft.thumbnail || "",
        thumbnailFileName: draft.thumbnailFileName || "",
        fileName: draft.fileName || "",
        journal_file_length: draft.journal_file_length || 0
      };

      payload.uuid = draft.uuid || "J-" + uuidv4();

      if (payload.thumbnailFileName) {
        payload.ThumbnailFileType = payload.thumbnailFileName.split(".").pop();
      }

      if (payload.ThumbnailPath && payload.ThumbnailPath.includes("data:image")) {
        payload.ThumbnailPath = "";
      }

      if (!payload.fileName) {
        const response = await api.update("journal", payload);
        if (response.status === 200 || response.status === 201) {
          return response.data || payload;
        }
        throw new Error("Failed to save journal.");
      }

      const fileExt = payload.fileName.split(".").pop().toLowerCase();
      const signedResponse = await api.post("journal/signed-url", {
        mimeType: fileExt,
        contentId: payload.uuid
      });

      if (signedResponse.status !== 200 && signedResponse.status !== 201) {
        throw new Error("Failed to upload file.");
      }

      await fetch(signedResponse.data.url, {
        method: "PUT",
        headers: {
          "Content-Type": fileExt
        },
        body: draft.file
      });

      const response = await api.update("journal", payload);
      if (response.status === 200 || response.status === 201) {
        return response.data || payload;
      }
      throw new Error("Failed to save journal.");
    },
    onNew() {
      this.isEdit = true;
      this.selectedObj.id = 0;
      this.selectedObj.Name = "";
      this.selectedObj.Description = "";
      this.selectedObj.Price = 0;
      this.selectedObj.Seat = 0;
      this.selectedObj.isCoreCollection = false;
      this.$refs.form.reset();
      this.cartItems.splice(0, this.cartItems.length);
      this.journalFilters = { issn: "", publisher: "", organization: "", Scope: "" };
    },
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getCollectionByPagin();
    },
    onSave() {
      let that = this;
      this.notify.type = 0;
      this.notify.errors = [];

      console.log(that.cartItems);
      console.log("selectedObj before save", that.selectedObj);
      if (this.selectedObj.collectionType === 1) {
        this.selectedObj.publications = [];
        for (let i = 0; i < that.cartItems.length; i++) {
          let obj = Object.assign({}, that.cartItems[i]);
          this.selectedObj.publications.push(obj);
        }
      } else if (this.selectedObj.collectionType === 2) {
        this.selectedObj.journals = [];
        for (let i = 0; i < that.cartItems.length; i++) {
          let obj = Object.assign({}, that.cartItems[i]);
          this.selectedObj.journals.push(obj);
        }
      }
      if (this.selectedObj.isCoreCollection == null) {
        this.selectedObj.isCoreCollection = false;
      }

      this.selectedObj.collectionType = this.selectedObj.collectionType;
       
      console.log(this.selectedObj);
      this.$refs.form.validate();

      if (this.selectedObj.Description == null || this.selectedObj.Description.length < 1 || !this.valid) return;

      if (this.cartItems.length <= 0) {
        this.notify.type = 4;
        this.notify.errors.push("Please add publications or journals.");
        return;
      }
      this.loading = true;
      that.overlay = true;
      console.log("updated cart",that.selectedObj);
      new Promise((resolve, reject) => {
        api
          .update("collection", this.selectedObj)
          .then(response => {
            if (response.status === 200 || response.status === 201) {
              this.notify.type = 1;
              this.notify.message =
                this.selectedObj.id === -1
                  ? "Record successfully saved."
                  : "Record successfully updated.";
              this.loading = false;
              this.isEdit = false;
              this.cartItems = [];
              this.getCollectionByPagin();
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
               if (this.selectedObj.collectionType === 2) {
                 for (let i = 0; i < this.resultQuery.length; i++) {
                   this.resultQuery[i].Publisher = this.publisher;
                   this.resultQuery[i].Organization = this.organization;
                   this.resultQuery[i].Scope = this.Scope;
                   this.saveSingleJournal(this.resultQuery[i]);
                 }
               }
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
              this.loading = false;
            }
            resolve(response);
            that.overlay = false;
            this.getJournals();
            this.getPublication();
          })
          .catch(error => {
            that.overlay = false;
            console.log(error);
            if (error.response.status == 409) {
              this.notify.type = 4;
              this.notify.errors.push("Collections name already exist");
              this.loading = false;
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              this.loading = false;
            }
            reject(error);
          });
      });
    },
    onEdit(obj) {
      this.isEdit = true;
      this.selectedObj = Object.assign({}, obj);
      if (obj.collectionType == 1) {
        this.getPublicationCollection(obj.id);
      }
      else if (obj.collectionType == 2) {
        this.getJournalCollection(obj.id);
      }
    },
    async onDelete(obj) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("collection", obj.id)
            .then(response => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                this.getCollectionByPagin();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch(error => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
    },
    onCancel() {
      this.isEdit = false;
    },
    getCollections() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getAll("collection")
          .then(response => {
            console.log(response);
            this.list = response.data;
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    onNextPage(page) {
      console.log("onNextPage " + page);
      this.paging.page = page;
      this.paging.keyword = this.Search;
      console.log(this.paging);

      this.getCollectionByPagin();
    },
    getCollectionByPagin() {
      let that = this;
      that.overlay = true;
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("collection", this.paging)
          .then(async response => {
            console.log(response);
            this.paging.count = response.data.count;
            this.list = [...this.list, ...response.data.data];
            that.overlay = false;
          })
          .catch(error => {
            that.overlay = false;
            reject(error);
          });
      });
    },
    getUserCollections() {
      new Promise((resolve, reject) => {
        api
          //.getAll("licenses/user-collection/1")  ///api/v1/licenses/opds/collection/{id}
          .getByID("licenses/opds/collection", 1)
          .then(response => {
            console.log(" opds " + response);
          })
          .catch(error => {
            console.log(" opds " + error);
            reject(error);
          });
      });
    },
    getJournals() {
      let that = this;
      that.overlay = true;
      this.users = [];
      new Promise((resolve, reject) => {
        api
          .getAll("Journal")
          .then(response => {
            console.log(response);
            this.journals = response.data;

            for (let i = 0; i < this.journals.length; i++) {
              this.journals[i].IsSelected = false;
              if (this.journals[i].Publisher == null)
                this.journals[i].Publisher = "";
            }
            that.overlay = false;
          })
          .catch(error => {
            that.overlay = false;
            reject(error);
          });
      });
    },
    getPublication() {
      let that = this;
      that.overlay = true;
      this.users = [];
      new Promise((resolve, reject) => {
        api
          .getAll("publications")
          .then(response => {
            console.log(response);
            this.publications = response.data;

            for (let i = 0; i < this.publications.length; i++) {
              this.publications[i].IsSelected = false;
              if (this.publications[i].PublisherName == null)
                this.publications[i].PublisherName = "";
            }
            that.overlay = false;
          })
          .catch(error => {
            that.overlay = false;
            reject(error);
          });
      });
    },
    getJournalCollection(id) {
      let that = this;
      that.overlay = true;
      this.selectedObj.journals = [];
      for (let i = 0; i < this.journals.length; i++) {
        this.journals[i].IsSelected = false;
      }
      new Promise((resolve, reject) => {
        api
          .getByID("journal-collection/journal", id)
          .then(response => {
            console.log("cart data id: ", response.data);
            that.cartItems.splice(0, that.cartItems.length);
            for (let i = 0; i < response.data.length; i++) {
              var objIndex = that.journals.findIndex(
                p => p.id == response.data[i].id
              );
              that.journals[objIndex].IsSelected = true;
              that.cartItems.push(that.journals[objIndex]);
            }
            this.journalFilters.issn = that.cartItems[0].ISSN;
            this.publisher = that.cartItems[0].Publisher;
            this.organization = that.cartItems[0].Organization;
            this.Scope = that.cartItems[0].Scope;
            that.SearchPublication = " ";
            that.SearchPublication = "";
            that.overlay = false;
          })
          .catch(error => {
            that.overlay = false;
            reject(error);
          });
      });
    },
    getPublicationCollection(id) {
      let that = this;
      that.overlay = true;
      this.selectedObj.publications = [];
      for (let i = 0; i < this.publications.length; i++) {
        this.publications[i].IsSelected = false;
      }
      new Promise((resolve, reject) => {
        api
          .getByID("publication-collection/publication", id)
          .then(response => {
            console.log(response.data.length, response.data);
            that.cartItems.splice(0, that.cartItems.length);
            for (let i = 0; i < response.data.length; i++) {
              var objIndex = that.publications.findIndex(
                p => p.id == response.data[i].id
              );
              that.publications[objIndex].IsSelected = true;
              that.cartItems.push(that.publications[objIndex]);
            }
            that.SearchPublication = " ";
            that.SearchPublication = "";
            that.overlay = false;
          })
          .catch(error => {
            that.overlay = false;
            reject(error);
          });
      });
    },
    onChangeUsers(items) {
      for (let i = 0; i < items.length; i++) {
        if (!(typeof this.selectedObj.publications[i] === "object")) {
          items.splice(i, 1);
          break;
        }
      }
    },
    addToCart(item) {
      let that = this;
      if (lodash.find(that.cartItems, { id: item.id }) == undefined) {
        if (item.ISSN == undefined) { 
          that.cartItems.push({
            id: item.id,
            Title: item.Title,
            ISBN: item.ISBN,
            Publisher: item.PublisherName,
            Action: item.id
          });
        } else {
          that.cartItems.push({
            id: item.id,
            Title: item.Title,
            ISSN: item.ISSN,
            Publisher: item.PublisherName || item.Publisher,
            Action: item.id
          });
        }
      }
      //that.cartItems.push(Object.assign({}, item));
    },
    removeFromCart(item) {
      let index = lodash.findIndex(this.cartItems, { id: item });
      if (index !== -1) {
        this.cartItems.splice(index, 1);
      }
    },
    isAdded(item) {
      let that = this;
      if (lodash.find(that.cartItems, { id: item.id }) == undefined) {
        return true;
      } else {
        return false;
      }
    },
    onDownloadPublications() {
      if (this.selectedObj.collectionType == 1) {
        api.getAll("publications").then((response) => {
          this.exportData = response.data;
          this.downloadPublicationMetadataAsCSV(this.exportData);
        });
      } else if (this.selectedObj.collectionType == 2) {
        api.getAll("journal").then((response) => {
          this.exportData = response.data;
          this.downloadPublicationMetadataAsCSV(this.exportData);
        });
      }
    },
    downloadPublicationMetadataAsCSV(json) {
      const parser = new Parser();
      const csv = parser.parse(
        json.map((pub) => this.mapPublicationMetadataToCSVRecord(pub))
      );

      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      var link = document.createElement("a");
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "publications-metadata.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    mapPublicationMetadataToCSVRecord(pub) {
      if (pub.ISSN == undefined) {
          return {
            id: pub.id || "",
            Title: pub.Title || "",
            ISBN: pub.ISBN || "",
            "Publisher Name": pub.PublisherName || "",
            "Include in Collection": false,
          };
      } else {
        return {
          id: pub.id || "",
          Title: pub.Title || "",
          ISSN: pub.ISSN,
          "Publisher Name": pub.PublisherName || "",
          "Include in Collection": false,
        };
      }
    },
    async onDataUpload(file) {
      if (this._uploading) return;
      this._uploading = true;

      this.overlay = true;
      
      if (!file) {
        this.overlay = false;
        this._uploading = false;
        return;
      }

      const confirmed = await this.$refs.confirm.open(
        "Confirm",
        "Are you sure you want to upload this file?"
      );

      if (!confirmed) {
        this.overlay = false;
        const input = this.$refs.dataUpload.$el.querySelector('input');
        if (input) input.value = null;
        this.$refs.dataUpload.reset();
        this._uploading = false;
        return;
      }

      try {
        const content = await fileUploadService.uploadFileReader(file);
        const uploadContent = await this.CsvToJson(content);
        const payloadContent = [];
        const validations = [];

        for (const item of uploadContent) {
            let isValid = true;
            const includeInCollection = item["Include in Collection"].toLocaleLowerCase() === 'true' ? true : item["Include in Collection"].toLocaleLowerCase() === 'false' ? false : item["Include in Collection"];
            if (!this.isColumnNotEmpty(includeInCollection)) {
              validations.push({Title: item.Title, ISBN: item.ISBN, PublisherName: item["Publisher Name"], Message: `"Include in Collection" column should be a True or False`, isSuccess: false  });
              isValid = false;
            }
            if (isValid && includeInCollection === true) {
              if (item.ISSN == undefined) {
                payloadContent.push({
                  id: Number(item.id) || "",
                  Title: item.Title || "",
                  ISBN: item.ISBN || "",
                  PublisherName: item["Publisher Name"] || "",
                  IsSelected: true,
                })
                validations.push({Title: item.Title, ISBN: item.ISBN, PublisherName: item["Publisher Name"], Message: `Added to Collection`, isSuccess: true  });
              } else {
                payloadContent.push({
                  id: Number(item.id) || "",
                  Title: item.Title || "",
                  ISSN: item.ISSN || "",
                  PublisherName: item["Publisher Name"] || "",
                  IsSelected: true,
                })
                validations.push({Title: item.Title, ISSN: item.ISSN, PublisherName: item["Publisher Name"], Message: `Added to Collection`, isSuccess: true  });
              }
              
            } else if (isValid && includeInCollection === false) {
              payloadContent.push({
                  id: Number(item.id) || "",
                  Title: item.Title || "",
                  ISBN: item.ISBN || "",
                  PublisherName: item["Publisher Name"] || "",
                  IsSelected: false,
                })
              validations.push({Title: item.Title, ISBN: item.ISBN, PublisherName: item["Publisher Name"], Message: `Removed from Collection`, isSuccess: true  });
            }
        }

        this.loading = true;

        if (payloadContent.length > 0) {
          for (const payloadItem of payloadContent) {
            if (payloadItem.IsSelected) {
              this.addToCart(payloadItem);
            } else {
              this.removeFromCart(payloadItem.id);
            }
          }
          this.$refs.uploadingStatus.open(validations);
        } else {
          this.$refs.uploadingStatus.open(validations);
        }
      } catch (error) {
        this.notify.type = 4;
        this.notify.errors.push("Failed to upload data. " + error);
      } finally {
        this.loading = false;
        this.overlay = false;
        const input = this.$refs.dataUpload.$el.querySelector('input');
        if (input) input.value = null;
        this.$refs.dataUpload.reset();
        this._uploading = false;
      }
    },
    async CsvToJson(content) {
      return new Promise((resolve,reject)=> {
        csv({
            noheader:false,
            output: "json",
            quote: '"',
            flatKeys: false,
            downstreamFormat: true
        }).fromString(content)
        .then((csvRow)=>{ 
            resolve(csvRow);
        })
      });    
    },
    isColumnNotEmpty(value) {
      if (typeof value !== 'boolean') {
        return false;
      }
      return true;
    },
    sortByName() {
    this.nameSortAsc = !this.nameSortAsc;
      this.list = this.list.sort((a, b) => this.nameSortAsc ? a.Name.localeCompare(b.Name) : b.Name.localeCompare(a.Name));
    },
    sortByType() {
      this.typeSortAsc = !this.typeSortAsc;
      this.list = this.list.sort((a, b) => this.typeSortAsc ? a.collectionType - b.collectionType : b.collectionType - a.collectionType);
    },
    sortByDescription() {
      this.descriptionSortAsc = !this.descriptionSortAsc;
      this.list = this.list.sort((a, b) => this.descriptionSortAsc ? a.Description.localeCompare(b.Description) : b.Description.localeCompare(a.Description));
    },
    
    sortByItemCount() {
      this.itemCountSortAsc = !this.itemCountSortAsc;
      this.list = this.list.sort((a, b) => this.itemCountSortAsc ? (a.itemCount || 0) - (b.itemCount || 0) : (b.itemCount || 0) - (a.itemCount || 0));
    },
    getCollectionList(collectionId, collectionType) {
  let endpoint = '';
  
  if (collectionType === 1) {
    // For book collections
    endpoint = "publication-collection/publication";
  } else if (collectionType === 2) {
    // For journal collections
    endpoint = "journal-collection/journal";
  }
  
  new Promise((resolve, reject) => {
    api
      .getByID(endpoint, collectionId)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          this.$refs.publicationList.open(response.data, collectionType); // Pass collectionType here
        }
      })
      .catch((error) => {
        console.error("Error fetching collection items:", error);
        reject(error);
      });
  });
  },
    getPublishers() {
    this.publishers = [];
    api.getAll("institutions")
      .then(response => {
        this.publishers = response.data || [];
      })
      .catch(err => {
        console.error("Failed to load publishers", err);
      });
    },
    sortByCreatedAt() {
      this.createdAtSortAsc = !this.createdAtSortAsc;
      this.list = this.list.sort((a, b) => {
        const dateA = new Date(a.createDateTime);
        const dateB = new Date(b.createDateTime);
        return this.createdAtSortAsc ? dateA - dateB : dateB - dateA;
      });
    },
    sortByUpdatedAt() {
      this.updatedAtSortAsc = !this.updatedAtSortAsc;
      this.list = this.list.sort((a, b) => {
        const dateA = new Date(a.modifiedDateTime);
        const dateB = new Date(b.modifiedDateTime);
        return this.updatedAtSortAsc ? dateA - dateB : dateB - dateA;
      });
    }
  },
  data() {
    return {
      list: [],
      publications: [],
      publishers: [],
      journals: [],
      collectionType: [
        { type: "Book", id: 1 },
        { type: "Journal", id: 2 }
      ],
      isEdit: false,
      isNew: false,
      Search: "",
      SearchPublication: "",
      journalFilters: { issn: "", publisher: "", organization: "", Scope: "" },
      searchUser: null,
      selectedObj: { isCoreCollection: false, collectionType: 1 },
      selectedCollection: [],
      notify: {
        type: 0,
        message: "",
        errors: []
      },
      valid: true,
      nameRules: [v => !!v || "Collection name is required"],
      descriptionRules: [v => !!v || "Collection description is required"],
      TitleRules: [v => !!v || "Title is required"],
      loading: false,
      paging: {
        count: 10,
        page: 1,
        size: 10,
        keyword: "",
        orderColumn: "Id",
        isASC: true
      },
      priceRules: [v => !!v || "Price is required"],
      seatRules: [v => !!v || "Seat is required"],
      overlay: false,
      newJournalDialog: false,
      newJournalValid: false,
      newJournalSaving: false,
      newJournalFileSize: 0,
      newJournal: {
        id: 0,
        Title: "",
        ISSN: "",
        Publisher: "",
        Organization: "",
        Scope: "",
        file: null,
        fileName: "",
        journal_file_length: 0,
        thumbnail: "",
        thumbnailData: "",
        thumbnailFileName: "",
        ThumbnailFileType: "",
        ThumbnailPath: "",
        ThumbnailPathOld: "",
        isDefaultThumbnail: false,
        uuid: ""
      },
      draftJournals: [],
      cartTableHeader: [
        {
          text: "Title",
          align: "start",
          sortable: false,
          value: "Title"
        },
        {
          text: "ISBN",
          align: "start",
          sortable: false,
          value: "ISBN"
        },
        {
          text: "Publisher",
          align: "start",
          sortable: false,
          value: "Publisher"
        },
        {
          text: "Action",
          align: "start",
          sortable: false,
          value: "Action"
        }
      ],
      journalCartTableHeader: [
        {
          text: "Title",
          align: "start",
          sortable: false,
          value: "Title"
        },
        {
          text: "ISSN",
          align: "start",
          sortable: false,
          value: "ISSN"
        },
        {
          text: "Publisher",
          align: "start",
          sortable: false,
          value: "Publisher"
        },
        {
          text: "Action",
          align: "start",
          sortable: false,
          value: "Action"
        }
      ],
      cartItems: [],
      fav: true,
      menu: false,
      message: false,
      hints: true,
      cart_page: 1,
      cart_pageCount: 0,
      cart_itemsPerPage: 10
    };
  }
};
</script>
<style scoped>
.icon-edit {
  color: #1975d2;
}
.icon-delete {
  color: red;
}
.col {
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/Collection.vue